import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LoadingService } from "./loading.service";

@Injectable({
  providedIn: "root",
})
export class DownloadService {
  constructor(
    private http: HttpClient,
    private loadingService: LoadingService
  ) {}

  downloadPDF(url: string, filename: string) {
    this.loadingService.start();
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/pdf",
        responseType: "blob",
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.blob();
      })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = filename || "animals-pois.pdf";
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        this.loadingService.complete();
      })
      .catch(() => {
        this.loadingService.complete();
      });
  }

  downloadImage(url: string) {
    const type = url.split(".").pop();
    const filename = url.split("/").pop();
    const encodeImgUrl = (url: string) => {
      const domain = url.slice(0, url.indexOf("/", 8) + 1);
      const folder = url.slice(url.indexOf("/", 8) + 1);
      const encode = folder.includes("/") ? encodeURIComponent(folder) : folder;
      return domain + encode;
    };
    this.loadingService.start();
    fetch(encodeImgUrl(url), {
      method: "GET",
      headers: {
        "Content-Type": "image/" + type,
        responseType: "blob",
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.blob();
      })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = filename || "wallpaper" + "." + type;
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        this.loadingService.complete();
      })
      .catch(() => {
        this.loadingService.complete();
      });
  }

  downloadFile(url: string, filename?: string): Promise<void> {
    this.loadingService.start();
    return fetch(url, {
      method: "GET",
      headers: {
        responseType: "blob",
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.blob();
      })
      .then(blob => {
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = filename || url.split("/").pop() || "download";
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        this.loadingService.complete();
      })
      .catch(error => {
        this.loadingService.complete();
        throw error;
      });
  }

  fetchImageAsBlob(url: string, signal?: AbortSignal): Promise<Blob> {
    const encodeImgUrl = (url: string) => {
      const domain = url.slice(0, url.indexOf("/", 8) + 1);
      const folder = url.slice(url.indexOf("/", 8) + 1);
      const encode = folder.includes("/") ? encodeURIComponent(folder) : folder;
      return domain + encode;
    };

    const fetchOptions: RequestInit = {
      method: "GET",
      signal: signal,
    };

    return fetch(encodeImgUrl(url), fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.blob();
      })
      .catch(error => {
        throw error;
      });
  }

  fetchFileAsBlob(url: string, signal?: AbortSignal): Promise<Blob> {
    const fetchOptions: RequestInit = {
      method: "GET",
      headers: {
        responseType: "blob",
      },
      signal: signal,
    };

    return fetch(url, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.blob();
      })
      .catch(error => {
        throw error;
      });
  }
}
